// extracted by mini-css-extract-plugin
module.exports = {"auth_page":"AuthContainer_auth_page__HXp2P","logo_margin":"AuthContainer_logo_margin__xlGYi"};